import { Stack } from "expo-router";
import React from "react";

/**
 * Stack layout navigator for the Messages tab, enabling URL-based
 * navigation to specific message details via /[id].
 */
export default function MessagesLayout() {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="[id]"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  );
}
